/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
import './gateway-log.scss';


/*@ngInject*/
export default function GatewayLogController($scope, $rootScope, $mdMedia, $translate, $document, $mdDialog, $filter, types, gatewayLogService) {
    var vm = this;

    vm.$onInit = function () {
        vm.types = types;
        vm.allGatewayLogs = [];
        vm.totalElemets = 0;
        vm.gatewayLogs = [];
        vm.rowsCount = 0;
        vm.query = {
            order: '-ts',
            limit: 15,
            page: 1,
        };
        vm.limitOptions = [15, 30, 45];
        vm.filter = {};

        vm.reload = reload;

        vm.loading = function () {
            return $rootScope.loading;
        };

        vm.onPaginate = function () {
            reload();
        };

        vm.onReorder = function () {
            updateGatewayLogs();
        };

        resetFilters();
        reload();
    };

    $scope.$watch("vm.filter.timewindow", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reload();
        }
    }, true);

    $scope.$watch("vm.filter.msgType", function (newVal, prevVal) {
        if (newVal && !angular.equals(newVal, prevVal)) {
            reload();
        }
    });

    $scope.$watch(function () {
        return $mdMedia('gt-md');
    }, function (isGtMd) {
        vm.isGtMd = isGtMd;
        if (vm.isGtMd) {
            vm.limitOptions = [15, 30, 45];
        } else {
            vm.limitOptions = null;
        }
    });

    function resetFilters() {
        vm.filter = {
            timewindow: {
                history: {
                    timewindowMs: 24 * 60 * 60 * 1000 // 1 day
                }
            },
            mac: '',
            msgType: [],
        };
    }

    function reload() {
        vm.gatewayLogs.length = 0;
        vm.rowsCount = 0;
        var startTs;
        var endTs;

        if (vm.filter.timewindow.history.timewindowMs) {
            var currentTime = (new Date).getTime();
            startTs = currentTime - vm.filter.timewindow.history.timewindowMs;
            endTs = currentTime;
        } else {
            startTs = vm.filter.timewindow.history.fixedTimewindow.startTimeMs;
            endTs = vm.filter.timewindow.history.fixedTimewindow.endTimeMs;
        }
        vm.gatewayLogPromise = gatewayLogService.getGatewayLog(startTs, endTs, vm.query.limit, (vm.query.page - 1), vm.filter.mac, vm.filter.msgType);

        if (vm.gatewayLogPromise) {
            vm.gatewayLogPromise.then(
                (result) => {
                    vm.allGatewayLogs = result.data;
                    vm.allGatewayLogs.forEach((gatewayLog) => {
                        gatewayLog.msgType = $translate.instant(vm.types.gatewayMsgType[gatewayLog.msgType].name);
                    });
                    vm.totalElemets = result.totalElements;
                    updateGatewayLogs();
                },
                () => {
                    updateGatewayLogs();
                }
            );
        }
    }

    function updateGatewayLogs() {
        var result = $filter('orderBy')(vm.allGatewayLogs, vm.query.order);
        if (vm.totalElemets > vm.query.limit) {
            vm.rowsCount = vm.totalElemets;
        } else {
            vm.rowsCount = result.length;
        }
        vm.gatewayLogs = result;
    }
}



// WEBPACK FOOTER //
// ./src/app/gateway-log/gateway-log.controller.js